import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38b689b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "currency-input-and-label" }
const _hoisted_2 = { class: "number-box" }

import { onMounted, ref, PropType } from "vue";
import { DxNumberBox, DxButton } from "devextreme-vue/number-box";
import { getCurrencyFormat } from "@/utils/CurrencyFormatter";
import { useCurrentUserStore } from "../../../stores/CurrentUserStore";
import { CurrentUser } from "@/types/user/CurrentUser";
import { FieldSize } from "@/enums/system/FieldSize";

// Rather than use the acquaint info box component which uses a textbox, we have a seperate info
// box for prices. Although we can use the mask prop for textboxes to set the values as being
// in a currency format, an '_' cna sometimes be added to the end whereas when we use a number box,
// this does not occur.


export default /*#__PURE__*/_defineComponent({
  __name: 'currency-info-box',
  props: {
  /**
   * The label displayed for the control.
   * @type {String}
   * @default ''
   */
  label: {
    type: String,
    default: "",
  },
  value: {
    type: Number,
    required: true,
  },
  width: {
    type: String as PropType<FieldSize>,
    default: FieldSize.Full,
  },
  icon: {
    type: String,
    default: "",
  },
},
  emits: ["iconClicked"],
  setup(__props, { emit }) {

const props = __props;

const currentUser = ref<CurrentUser>();
const currentUserStore = useCurrentUserStore();
const countryCodeID = ref<number>();



onMounted(async () => {
  // Get Current User details from the Current User store
  currentUser.value = await currentUserStore.getCurrentUserDetails();

  // Retrieve the Country Code ID to use for Formatting the Currency
  countryCodeID.value = currentUser.value?.countryCodeID;
});



const onIconClicked = () => emit("iconClicked");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(props.label), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DxNumberBox), {
        format: _unref(getCurrencyFormat)(countryCodeID.value),
        value: props.value,
        width: props.width,
        readOnly: true
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            name: "info-box-icon",
            position: "after",
            options: {
            icon: __props.icon,
            stylingMode: 'text',
            type: 'dx-dropdowneditor-button',
            disabled: false,
            visible: __props.icon,
            onClick: onIconClicked,
          }
          }, null, 8, ["options"])
        ]),
        _: 1
      }, 8, ["format", "value", "width"])
    ])
  ]))
}
}

})